export const CONTRACT_TYPES_GROUPING_MODEL = "contract-types-grouping";

const contractTypesGroupingModel = {
  name: ""
};

export default contractTypesGroupingModel;
